module.exports = __webpack_public_path__ + "static/media/Time track white.890507b5.svg";